var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPaperPlane = function SvgPaperPlane(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2258 2.44553L2.88569 11.8686C1.53449 12.6502 1.66411 14.6495 3.10958 15.2426L7.59918 17.1005V20.4157C7.59918 22.2382 9.9245 22.9885 11.0007 21.5391L12.7212 19.2177L17.1165 21.0324C17.3482 21.1266 17.5918 21.1738 17.8353 21.1738C18.1574 21.1738 18.4756 21.0913 18.7623 20.9303C19.2651 20.6474 19.6107 20.1447 19.7011 19.5751L22.0342 4.36628C22.2738 2.79119 20.5848 1.66388 19.2258 2.44553ZM9.48458 20.4157V17.8783L10.9222 18.4714L9.48458 20.4157ZM17.8353 19.2884L11.7942 16.7942L17.3011 8.84802C17.7214 8.23919 16.928 7.53217 16.3702 8.0153L8.06267 15.2544L3.82839 13.5026L20.1685 4.07561L17.8353 19.2884Z",
    fill: "#16181A"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPaperPlane, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/paper-plane.b1b85716.svg";
export { ForwardRef as ReactComponent };